import React from 'react';

import type { InstagramStoryComponentsProps } from './types';

export function Body(_props: InstagramStoryComponentsProps): React.JSX.Element {
	return <div>Instagram Story Body</div>;
}
